<a class="skip-link" href="#main-content">Skip to main content</a>

<app-header id="header" role="banner"></app-header>

<div class="floating-cart" #floatingCart>
  <a routerLink="/cart">
    <i class="icon-shopping-cart"></i>
    <span class="cart-count">{{ cartLength }}</span>
  </a>
</div>

<main id="main-content" role="main" tabindex="-1">
  <router-outlet (activate)="scroll()"></router-outlet>
</main>

<app-footer id="footer"></app-footer>

<app-cookie-consent></app-cookie-consent>
<app-loader-modal></app-loader-modal>
<app-age-verify *ngIf="isBrowser && !ageGate.ageVerified()"></app-age-verify>
